<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">
    <h1 class="questions__header">{{ $t("Rounding rules") }}</h1>

    <b-form-checkbox
      v-model="enableClockSettings"
      @change="deleteAllRules"
      name="check-button"
      switch>
      {{ $t("Yes, we are going to register hours with Dyflexis") }}
    </b-form-checkbox>

    <div v-show="enableClockSettings">
      <p class="question--marginTop">{{
          $t("You can choose how the shifts are rounded, for example, do you pay out in fifteen minutes or half hours? Or do you want the clock times not to be rounded, or rounded to a number of minutes? It is also possible to round off clock times per working hour or per clock moment. In this case, intermediate clocking in and out such as breaks will also be rounded.")
        }}</p>

      <p class="questions--noinputmargin">{{ $t("How to round") }}</p>

      <b-form-checkbox
        v-model="showWorkDay" class="checkbox" name="check-button" switch>
        {{ $t("Round total shift times") }}
      </b-form-checkbox>

      <b-form-checkbox
        v-model="showClockItem" class="checkbox" name="check-button" switch>
        {{ $t("Round clock times") }}
      </b-form-checkbox>

      <div v-show="showWorkDay">
        <h2 class="questions__subheader questions__header">{{ $t("Round total shift times") }}</h2>

        <div v-for="(workDayRule, index) in roundSettings.workDayRules">
          <p :class="{questions__devide: index > 0}" class="question__paragraph-margin questions--noinputmargin">
            {{ $t("This rounding rule applies for") }}</p>
          <input
            v-model="workDayRule.name"
            :disabled="readOnly"
            class="form-control workDayRuleName"
            type="text"
          />
          <b-button
            :disabled="readOnly"
            class="workDayRule__delete"
            variant="danger"
            @click="deleteWorkDayRule(index)">
            {{ $t("Delete") }}
          </b-button>

          <p class="question__paragraph-margin questions--noinputmargin">
            {{ $t("Round total shift times on") }}</p>
          <b-form-select
            id="questions-dropdownHalf"
            v-model="workDayRule.roundMinutes"
            :disabled="readOnly">
            <option
              value="0">
              {{ $t("Do not round") }}
            </option>
            <option value="5">
              {{ $t("5 minutes") }}
            </option>
            <option value="10">
              {{ $t("10 minutes") }}
            </option>
            <option value="15">
              {{ $t("15 minutes") }}
            </option>
            <option value="20">
              {{ $t("20 minutes") }}
            </option>
            <option value="30">
              {{ $t("30 minutes") }}
            </option>
            <option value="60">
              {{ $t("60 minutes") }}
            </option>
          </b-form-select>

          <p class="questions--noinputmargin questions__subspace"><b>{{ $t("Crop to schedule") }}</b></p>
          <p class="question-paragraph__margin">{{
              $t("If employees clock in earlier than the start time of their shift, or clock out later than the end time of their shift, will you pay this time? To answer this, complete the sentences below:")
            }}</p>
          <p>
            {{ $t("Ignore clocked time") }} <input
            v-model="workDayRule.ignoreEarlyClockInMinutes"
            :disabled="readOnly"
            class="form-control questions--minutesBreak"
            min="1"
            type="number"/> {{ $t("min. before scheduled start time and") }}
            <input
              v-model="workDayRule.ignoreOverWorkMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min. after scheduled end time.") }}
          </p>

          <p class="questions--noinputmargin questions__subspace"><b>{{ $t("Rounding boundaries") }}</b></p>
          <p>{{
              $t("If employees are allowed to come in late or leave early without the times being  rounded up in favour of the employer, you can specify the number of minutes before and after the shift here:")
            }}</p>
          <p>
            {{ $t("Start time:") }}
            <input
              v-model="workDayRule.ignoreLateClockInMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min.") }} {{ $t("End time:") }}
            <input
              id="roundEndWorkHours"
              v-model="workDayRule.ignoreEarlyClockOutMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min.") }}
          </p>
        </div>

        <b-button
          variant="success"
          @click="addWorkDayRule">
          +
        </b-button>
      </div>

      <div v-show="showClockItem">
        <h2 class="questions__subheader questions__header">{{ $t("Round clock times") }}</h2>
        <div v-for="(clockItemRule, index) in roundSettings.clockItemRules">
          <p :class="{questions__devide: index > 0}" class="question__paragraph-margin questions--noinputmargin">
            {{ $t("This rounding rule applies for") }}</p>
          <input
            v-model="clockItemRule.name"
            :disabled="readOnly"
            class="form-control workDayRuleName"
            type="text"
          />
          <b-button
            :disabled="readOnly"
            class="workDayRule__delete"
            variant="danger"
            @click="deleteClockItemRule(index)">
            {{ $t("Delete") }}
          </b-button>
          <p class="question__paragraph-margin questions--noinputmargin">
            {{ $t("Round clock times on") }}</p>
          <b-form-select
            id="questions-dropdownHalf"
            v-model="clockItemRule.roundMinutes"
            :disabled="readOnly">
            <option
              value="0">
              {{ $t("Do not round") }}
            </option>
            <option value="5">
              {{ $t("5 minutes") }}
            </option>
            <option value="10">
              {{ $t("10 minutes") }}
            </option>
            <option value="15">
              {{ $t("15 minutes") }}
            </option>
            <option value="20">
              {{ $t("20 minutes") }}
            </option>
            <option value="30">
              {{ $t("30 minutes") }}
            </option>
            <option value="60">
              {{ $t("60 minutes") }}
            </option>
          </b-form-select>

          <p class="questions--noinputmargin questions__subspace"><b>{{ $t("Rounding boundaries") }}</b></p>
          <p class="question-paragraph__margin">{{
              $t("If employees clock in earlier than the start time of their shift, or clock out later than the end time of their shift, will you pay this time? To answer this, complete the sentences below:")
            }}</p>
          <p>
            {{ $t("Ignore clocked time") }} <input
            v-model="clockItemRule.ignoreEarlyClockInMinutes"
            :disabled="readOnly"
            class="form-control questions--minutesBreak"
            min="1"
            type="number"/> {{ $t("min. before scheduled start time and") }}
            <input
              v-model="clockItemRule.ignoreOverWorkMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min. after scheduled end time.") }}
          </p>

          <p class="questions--noinputmargin questions__subspace"><b>{{ $t("Crop to schedule") }}</b></p>
          <p>{{
              $t("If employees are allowed to come in late or leave early without the times being  rounded up in favour of the employer, you can specify the number of minutes before and after the shift here:")
            }}</p>
          <p>
            {{ $t("Start time:") }}
            <input
              v-model="clockItemRule.ignoreLateClockInMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min.") }} {{ $t("End time:") }}
            <input
              id="roundEndWorkHours"
              v-model="clockItemRule.ignoreEarlyClockOutMinutes"
              :disabled="readOnly"
              class="form-control questions--minutesBreak"
              min="1"
              type="number"/> {{ $t("min.") }}
          </p>
        </div>
        <b-button
          variant="success"
          @click="addClockItemRule">
          +
        </b-button>
      </div>

      <h1 class="question--marginTop questions__header">{{ $t("Clock breaks") }}</h1>
      <b-form-group :label="$t('Are employees supposed to clock their breaks?')">
        <b-form-radio v-model="roundSettings.clockBreaks" class="fit-content" name="clockBreaks" value="no">
          {{ $t("No, breaks are not clocked") }}
        </b-form-radio>
        <b-form-radio v-model="roundSettings.clockBreaks" class="fit-content" name="clockBreaks" value="indicator">
          {{ $t("Indicative: the break rule is leading, but the actual timed break is shown as an indication") }}
        </b-form-radio>
        <b-form-radio v-model="roundSettings.clockBreaks" class="fit-content" name="clockBreaks" value="clockedLeading">
          {{ $t("Clocked break is leading: the clocked break is deducted from the hours worked") }}
        </b-form-radio>
        <b-form-radio v-model="roundSettings.clockBreaks" class="fit-content" name="clockBreaks" value="ruleElseClocked">
          {{ $t("Clocking less break than the break rule: round up to the break rule, with too much break time clocks deduct from the hours worked") }}
        </b-form-radio>
      </b-form-group>

      <div v-show="contractType === 'PROPLUS'">
        <h1 class="question--marginTop questions__header">{{ $t("Cost center switching") }}</h1>
        <p>{{ $t("Should it be possible for employees to switch between different cost centers during their shift?") }}</p>
        <b-form-checkbox
          v-model="roundSettings.costCenterSwitching" class="checkbox" name="check-button" switch>
          {{ $t("Yes, enable cost center switching") }}
        </b-form-checkbox>
      </div>

      <h1 class="question--marginTop questions__header">{{ $t("Remarks") }}</h1>
      <h2 class="questions__subheader">{{ $t("Remarks") }}</h2>
      <b-form-textarea
        v-model="roundSettings.clockRulesRemarks"
        class="questions__textarea"
        rows="3"/>
    </div>
    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: "RoundingSettings",
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      readOnly: false,
      showWorkDay: false,
      showClockItem: false,
      enableClockSettings: false,
      contractType: null,
      roundSettings: {
        workDayRules: [],
        clockItemRules: [],
        clockBreaks: 'no',
        costCenterSwitching: false,
        clockRulesRemarks: null,
      }
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    this.contractType = result.contractType;
    this.roundSettings.clockRulesRemarks = result.clockRulesRemarks;

    if (result.clockRules !== null) {
      let clockRules = null;
      try {
        clockRules = JSON.parse(this.removeHtml(result.clockRules.replaceAll("&quot;", '"')));
      } catch (e) {
        localStorage.setItem('startingObject', JSON.stringify(this.roundSettings));
        this.displayFrontend = true;
        return false;
      }

      if (clockRules.workDayRules !== undefined && clockRules.workDayRules.length !== 0) {
        this.roundSettings.workDayRules = clockRules.workDayRules;
        this.enableClockSettings = true;
        this.showWorkDay = true;
      }

      if (clockRules.clockItemRules !== undefined && clockRules.clockItemRules.length !== 0) {
        this.roundSettings.clockItemRules = clockRules.clockItemRules;
        this.enableClockSettings = true;
        this.showClockItem = true;
      }

      if (clockRules.clockBreaks !== undefined) {
        this.roundSettings.clockBreaks = clockRules.clockBreaks;
      }

      if (clockRules.costCenterSwitching !== undefined) {
        this.roundSettings.costCenterSwitching = clockRules.costCenterSwitching;
      }


      // Makes it backwards compatible. This can be removed after october 2022
      if (!this.enableClockSettings) {
        if (clockRules.workDayRules === undefined && clockRules.roundBasedOn !== 'clockItem') {
          this.roundSettings.workDayRules.push({
            name: null,
            roundMinutes: clockRules.roundMinutes,
            ignoreEarlyClockInMinutes: clockRules.ignoreEarlyClockInMinutes,
            ignoreOverWorkMinutes: clockRules.ignoreOverWorkMinutes,
            ignoreLateClockInMinutes: clockRules.ignoreLateClockInMinutes,
            ignoreEarlyClockOutMinutes: clockRules.ignoreEarlyClockOutMinutes,
          });
          this.showWorkDay = true;
          this.enableClockSettings = true;
        }

        // Makes it backwards compatible. This can be removed after october 2022
        if (clockRules.clockItemRules === undefined && clockRules.roundBasedOn === 'clockItem') {
          this.roundSettings.clockItemRules.push({
            name: null,
            roundMinutes: clockRules.roundMinutes,
            ignoreEarlyClockInMinutes: clockRules.ignoreEarlyClockInMinutes,
            ignoreOverWorkMinutes: clockRules.ignoreOverWorkMinutes,
            ignoreLateClockInMinutes: clockRules.ignoreLateClockInMinutes,
            ignoreEarlyClockOutMinutes: clockRules.ignoreEarlyClockOutMinutes,
          });
          this.showClockItem = true;
          this.enableClockSettings = true;
        }
      }
    }

    this.readOnly = result.isSigned;
    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.roundSettings));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.roundSettings, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;
      const result = await SystemRequestService.updateProject(this.roundSettings, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.roundSettings));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
    removeHtml(text) {
      if (text == null) {
        return text;
      }

      let tmp = document.createElement("DIV");
      tmp.innerHTML = text;
      return tmp.textContent || tmp.innerText || "";
    },
    addWorkDayRule() {
      this.roundSettings.workDayRules.push({
        name: null,
        roundMinutes: 15,
        ignoreEarlyClockInMinutes: null,
        ignoreOverWorkMinutes: null,
        ignoreLateClockInMinutes: null,
        ignoreEarlyClockOutMinutes: null
      });
      this.$forceUpdate();
    },
    addClockItemRule() {
      this.roundSettings.clockItemRules.push({
        name: null,
        roundMinutes: 15,
        ignoreEarlyClockInMinutes: null,
        ignoreOverWorkMinutes: null,
        ignoreLateClockInMinutes: null,
        ignoreEarlyClockOutMinutes: null
      });
      this.$forceUpdate();
    },
    deleteWorkDayRule(index) {
      this.roundSettings.workDayRules.splice(index, 1);
      this.$forceUpdate();
    },
    deleteClockItemRule(index) {
      this.roundSettings.clockItemRules.splice(index, 1);
      this.$forceUpdate();
    },
    deleteAllRules() {
      this.showWorkDay = false;
      this.showClockItem = false;
      this.roundSettings.workDayRules = [];
      this.roundSettings.clockItemRules = [];
      this.roundSettings.clockRulesRemarks = '';
    }
  },
};
</script>
